export default __webpack_public_path__ + "static/media/sensors.0de39361.png";